<template>
  <!--<div>-->
  <!--</div>-->
  <el-cascader v-bind="$attrs" v-on="$listeners" :options="treeData" :value="value" :show-all-levels="false" @change="handleItemChange" change-on-select clearable filterable>
  </el-cascader>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

const lodash = require('lodash');

export default {
  name: 'depCodeTree',
  props: {
    depCode: {
      type: String,
    },
    value: {
      type: Array,
      default: () => [],
    },
    /**
     * 模式：
     */
    mood: {
      type: String,
      default: 'base',
    },
    isShowDeepName: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timer: null,
      treeData: [],
      oTreeData: [],
      treeObject: {},
      data: {
        depCode: '',
        depName: '',
        depNameAbb: '',
        level: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      userInfor: 'user/userInfor',
    }),
  },
  methods: {
    ...mapActions({
      setCommData: 'depCode/setCommData',
    }),
    transforList(Obj) {
      let list = [];
      Object.keys(Obj).forEach(key => {
        let l = JSON.parse(JSON.stringify(Obj[key]));
        if (Obj[key].children && JSON.stringify(Obj[key].children) !== {}) {
          l.children = this.transforList(Obj[key].children);
        }
        else if (Obj[key].children === null) {
          delete l.children;
        }
        list.push(l);
      });
      return list;
    },
    async getListAllChildDepTree(depCode, depCodes) {
      const { bean } = await this.$services.post({
        type: 'DEPT',
        url: 'getListAllChildDepAjax',
        params: { depCode: depCode ? depCode : this.userInfor.depCode },
      });
      this.oTreeData = this.transforTree(bean, depCodes);
      this.treeData = this.transforList(this.treeObject);
    },
    async handleItemChange(val) {
      const index = val.length - 1;
      const _depcode = val[index];
      await this.getListAllChildDepTree(_depcode, val);
    },
    init() {
      if (this.oTreeData.length > 0) {
        return new Promise(resolve => {
          resolve(true);
        });
      }
      return this.getListAllChildDepTree();
    },
    /**
     * 数据转成treeData
     */
    transforTree(treeData, depCodes = []) {
      if (!treeData || treeData.length === 0) {
        if (
          depCodes.length
          && lodash.get(this.treeObject, depCodes.join(',children,').split(','))
        ) {
          lodash.get(
            this.treeObject,
            depCodes.join(',children,').split(','),
          ).children = null;
        }
        return [];
      }
      const childs = [];
      let treeObj = {};
      treeData.forEach(tree => {
        if (
          depCodes.length
          && lodash.get(this.treeObject, depCodes.join(',children,').split(','))
        ) {
          lodash.get(
            this.treeObject,
            depCodes.join(',children,').split(','),
          ).children[tree.depCode] = {
            value: tree.depCode,
            label: tree.name,
            depName: tree.name,
            depCode: tree.depCode,
            children: {},
          };
        }
        else {
          // this.treeObject[tree.depCode] = {
          //   value: tree.depCode,
          //   label: tree.name,
          //   depName: tree.name,
          //   depCode: tree.depCode,
          //   children: {}
          // };
          treeObj[tree.depCode] = {
            value: tree.depCode,
            label: tree.name,
            depName: tree.name,
            depCode: tree.depCode,
            children: {},
          };
          if (this.isShowDeepName) {
            // 显示根节点
            this.treeObject[this.userInfor.depCode] = {
              value: this.userInfor.depCode,
              label: this.userInfor.departName,
              depName: this.userInfor.departName,
              depCode: this.userInfor.depCode,
              children: treeObj,
            };
            // 设置默认
            // console.warn('设置默认');
            // this.handleItemChange([this.userInfor.depCode]);
          }
          else {
            this.treeObject = treeObj;
          }
        }
        childs.push({
          value: tree.depCode,
          label: tree.name,
          depName: tree.name,
          depCode: tree.depCode,
          children: [],
        });
      });
      this.$forceUpdate();
      return childs;
    },
    /**
     * 遍历循环每个节点机构
     */
    async loopItemChange(arry, index = 1) {
      if (index <= arry.length) {
        this.handleItemChange(arry.slice(0, index)).then(() => {
          index += 1;
          this.loopItemChange(arry, index);
        });
      }
      else {
        console.warn('loop end');
      }
    },
  },
  watch: {
    depCode: {
      handler(str) {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          clearTimeout(this.timer);
          this.init().then(() => {
            if (str) {
              let gxdwdm = [];
              this.$utils.getDepCodeArryWithUser(
                this.userInfor.depCode,
                str,
                gxdwdm,
                this.isShowDeepName,
              );
              this.$emit('input', gxdwdm);
              this.loopItemChange(gxdwdm);
            }
          });
        }, 300);
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>
<style lang="scss">
.el-cascader.is-disabled {
  .el-cascader__label {
    cursor: not-allowed;
  }
}
</style>
